module.exports = __webpack_public_path__ + "static/media/logo-comune-maranello.130403cb.webp";